import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';

import './Search.css';

import Search from './Search';
import { requestCustomerList } from '../../actions/customer';
import CustomersDropdown from './CustomerSearch/CustomersDropdown';
import EndCustomersDropdown from './CustomerSearch/EndCustomersDropdown';

class SearchTools extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCustomer: undefined,
      customerName: undefined,
      endCustomerName: undefined,
      searchTerms: undefined,
      isEndCustomerDisabled: false,
    };
  }

  componentWillMount() {
    const { requestCustomerList } = this.props;
    requestCustomerList();
  }

  onSearchTermsUpdated(terms) {
    const { searchUpdated, customers, session: { isAdmin = false } } = this.props;

    this.setState(terms);

    if (searchUpdated) {
      const { customerName: selectedCustomerName, endCustomerName, searchTerms } = this.state;
      const canSelectCustomer = !!isAdmin || customers.length > 1;
      const firstCustomerName = customers.length > 0 ? customers[0].name : null;

      const searchFilters = {
        customerName: canSelectCustomer ? selectedCustomerName : firstCustomerName,
        endCustomerName,
        searchTerms,

        ...terms,
      };

      searchUpdated(searchFilters);
    }
  }

  onCustomerSelected = (customers) => {
    const selectedCustomer = [];
    const { resetSelect } = this.state;
    if (resetSelect) {
      this.setState({ resetSelect: false });
    }

    if (customers !== null) {
      // eslint-disable-next-line
      customers.map((customer) => {
        if (customer.value !== '') {
          this.setState({ reset: true });
          if (customers.length > 1) {
            this.setState({ isEndCustomerDisabled: true });
          } else {
            this.setState({ isEndCustomerDisabled: false });
            this.setState({ customerName: customers[0].value });
          }
          selectedCustomer.push(customer.value);
        }
      });
    } else {
      this.setState({ reset: true });
      this.setState({ isEndCustomerDisabled: false });
      this.setState({ customerName: null });
    }

    this.onSearchTermsUpdated({
      selectedCustomer,
      endCustomerName: [],
    });
  }

  onEndCustomerSelected = (endCustomers) => {
    const endCustomerName = [];
    if (endCustomers !== null) {
      // eslint-disable-next-line
      endCustomers.map((endCustomer) => {
        endCustomerName.push(endCustomer.value);
      });
    }
    if (endCustomers != null) {
      this.setState({ reset: false });
    }

    this.onSearchTermsUpdated({
      endCustomerName,
    });
  }

  onExecuteSearch = (searchTerms) => {
    searchTerms = searchTerms && searchTerms.length > 0 ? searchTerms : undefined;

    this.onSearchTermsUpdated({
      searchTerms,
    });
  }

  getCustomerOptions() {
    const { translate, customers = [] } = this.props;

    if(customers.length > 0) {
      const firstOption = {
        value: '',
        text: translate('search.select_customer'),
      };
      const names = customers.map((customer) => customer.name).sort();
      const options = names.map((name) => ({
        value: name,
        text: name,
      }));

      return [firstOption, ...options];
    } else {
      return [];
    }
  }

  getEndCustomerNames(destinations) {
    if (!destinations) {
      return [];
    }
    const endCustomerFilterData = new Set();
    destinations.forEach((destination) => {
      if (destination.internalStatus.toUpperCase() === 'PUBLISHED'
        || destination.internalStatus.toUpperCase() === 'ORDERED') {
        endCustomerFilterData.add({ "endCustomer": destination.companyName, "destinationId": destination.id });
      }
    });
    return Array.from(endCustomerFilterData).sort();
  }

  getEndCustomerOptions(customerName) {
    const { translate, customers = [] } = this.props;

    if(customers.length > 0) {
      const selectedCustomers = customers.filter((customer) => customer.name === customerName);
      const names = new Set();
      selectedCustomers.forEach((customer) => {
        const endCustomerNames = this.getEndCustomerNames(customer.destinations);
        endCustomerNames.forEach((endCustomerName) => {
          names.add(endCustomerName);
        });
      });
      const sortedNameArray = Array.from(names).sort();

      const options = sortedNameArray.map((name) => ({
        value: name,
        text: name,
      }));

      const firstOption = {
        value: '',
        text: translate('search.select_endcustomer'),
      };

      return [firstOption, ...options];
    } else {
      return [];
    }

  }

  resetAppliedSearchCriteria = (evt) => {
    const { resetFilter } = this.props;
    this.setState({ reset: evt, resetSelect: evt });
    this.setState({ endCustomerName: undefined });
    this.setState({ isEndCustomerDisabled: false });
    resetFilter({ resetFilter: evt });
    this.onSearchTermsUpdated({
      selectedCustomer: [],
      customerName: '',
      searchTerms: '',
    });
  }

  render() {
    const {
      translate, session: { isAdmin = false }, customers, resetSearchTerm,
    } = this.props;
    const {
      customerName: selectedCustomerName, isEndCustomerDisabled, reset, resetSelect,
    } = this.state;

    const canSelectCustomer = !!isAdmin || customers.length > 1;
    const firstCustomerName = customers.length > 0 ? customers[0].name : null;
    const customerName = canSelectCustomer ? selectedCustomerName : firstCustomerName;

    return (
      <div className="row search-tools">
        {canSelectCustomer
        && (
        <div className="col-sm-4">
          <CustomersDropdown data={this.getCustomerOptions()}
                             placeholder={translate('search.select_customer')}
                             onChange={this.onCustomerSelected}
                             reset={resetSelect} />
        </div>
        )}
        <div className="col-sm-4">
          <EndCustomersDropdown data={this.getEndCustomerOptions(customerName)}
                                placeholder={translate('search.select_endcustomer')}
                                disabled={isEndCustomerDisabled}
                                onChange={this.onEndCustomerSelected}
                                reset={reset} />
        </div>
        <div className="col-sm-4">
          <Search resetSearchTerm={resetSearchTerm}
                  resetFilter={this.resetAppliedSearchCriteria}
                  resetbutton={translate('work_list.search.reset_all')}
                  placeholder={translate('search.query_hint')}
                  executeSearch={this.onExecuteSearch} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  translate: getTranslate(state.locale),
  customers: state.customer.customers,
  session: state.session,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  requestCustomerList,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchTools);



// WEBPACK FOOTER //
// ./src/components/search/SearchTools.js